module.exports = __webpack_public_path__ + "img/user.c61929a7.png";